<template>
	<footer class="footer">
		<div class="i_maxW">
			<div class="i_copyright">{{copyRight}}</div>
		</div>
	</footer>
</template>
<script>


export default {
    data() {
        return {
           copyRight:'',
        };
    },
    created() {
        this.getCpoyRight();
    },
    methods: {
    	getCpoyRight(){
    		let success = data => {
                this.copyRight = data.data.info.info_copyright;
            };
            let fail = data => {}
            this.$ajax({
                url: "api/setting/page_foot",
                method: "get",
                params: {},
                func: {
                    success: success,fail:fail
                }
            });
    	}
    }
 }

</script>
<style lang="scss">
	.footer{
		background-color: #3a486f;
	}
	.i_copyright {
	    line-height: 16px;
	    color: #fff;
	    padding: 14px 0;
	    text-align: center;
        white-space:pre
	}
</style>